import BackgroundVideo from '../../src/modules/BackgroundVideo';
import BackgroundImage from '../../src/modules/BackgroundImage';


customElements.define(

  "cc-section-media", 

  class extends HTMLElement{

        connectedCallback(){
            let height = this.getAttribute("height");
            const videoURL = this.getAttribute("video");
            const imageURL = this.getAttribute("image");
            const element = this.innerHTML;

            if( height == "" || !height ){
                height = "auto";
            }
            
            this.innerHTML = `
            <section id="cc-custom-section-media">

                <div class="media image">

                </div>
                <div class="media video">

                </div>
                <div class="media foreground">

                    <div id="content-wrapper">

                        <div id="content" style="min-height:${height};">
                            ${element}
                        </div>

                    </div>

                </div>

            </section>      

            `;
            
            let videoContainer = this.querySelector(".video");

            let imageContainer = this.querySelector(".image");

            if (videoContainer && videoURL != "" && videoURL ) { 

                new BackgroundVideo(videoURL, videoContainer)

            }
            if (imageContainer && imageURL != "" && imageURL) { 

                new BackgroundImage(imageURL, imageContainer);

            }


        }
       
    }

);